(function () {
  'use strict';

  // ── Produktkarte Blob ────────────────────────────────────────
  var ORIG_D = 'M31.1932 66.0553C33.1891 32.747 62.0016 38.5886 97.8419 37.8213C133.682 37.0579 137.662 -1.16534 168.419 0.0273697C199.076 1.22008 207.087 30.5949 205.352 44.2351C202.46 66.9534 202.176 81.2343 215.613 98.916C229.046 116.594 258.368 142.628 219.909 166.657C185.565 188.114 174.511 201.911 168.267 214.363C163.658 223.559 151.946 233.311 136.718 234.85C119.728 236.563 112.762 223.378 103.273 208.918C90.7366 189.808 84.8357 180.84 56.2313 178.758C1.84456 174.8 -13.7486 129.671 12.3294 113.558C40.3294 96.2566 29.9321 87.034 31.1888 66.0553L31.1932 66.0553Z';

  // ── Header Logo Blob (Blob5) ─────────────────────────────────
  var HEADER_BLOB_D = 'M41.5396 129.791C39.9143 74.296 88.4489 79.7215 147.634 73.1564C206.819 66.5976 207.748 2.66489 258.812 0.0987669C309.711 -2.45258 327.311 45.0454 326.458 67.9066C325.035 105.983 326.678 129.692 351.525 157.01C376.365 184.323 428.73 223.137 368.655 268.638C315.007 309.271 298.76 333.769 290.27 355.326C284.004 371.247 266.07 389.139 241.102 393.938C213.246 399.286 199.77 378.465 181.932 355.902C158.363 326.084 147.273 312.093 99.6388 312.868C9.06999 314.342 -23.4055 241.855 17.357 211.301C61.1236 178.492 42.5568 164.744 41.5324 129.791L41.5396 129.791Z';

  // Parse path into { start, segs[] } where each seg = { cp1, cp2, end }
  function parsePath(d) {
    var n = d.match(/-?[\d.]+(?:e[-+]?\d+)?/gi).map(Number);
    var i = 0;
    var start = { x: n[i++], y: n[i++] };
    var segs = [];
    while (i + 5 < n.length) {
      segs.push({
        cp1: { x: n[i++], y: n[i++] },
        cp2: { x: n[i++], y: n[i++] },
        end: { x: n[i++], y: n[i++] }
      });
    }
    return { start: start, segs: segs };
  }

  // Rotate point (px,py) around (ax,ay) by angle radians
  function rotateAround(px, py, ax, ay, angle) {
    var c = Math.cos(angle), s = Math.sin(angle);
    var dx = px - ax, dy = py - ay;
    return { x: ax + dx * c - dy * s, y: ay + dx * s + dy * c };
  }

  function f(n) { return n.toFixed(2); }

  // Build morphed path at time t (ms), amplitude scale 0–1
  function buildPath(orig, params, t, amp) {
    var segs = orig.segs;
    var N = segs.length;

    // Displaced anchor positions for each segment
    var anchors = segs.map(function (seg, i) {
      var p = params[i];
      return {
        x: seg.end.x + amp * p.ax * Math.sin(p.fx * t + p.px),
        y: seg.end.y + amp * p.ay * Math.cos(p.fy * t + p.py)
      };
    });

    // Start point shares params with last segment (same anchor)
    var sp = params[N - 1];
    var sx = orig.start.x + amp * sp.ax * Math.sin(sp.fx * t + sp.px);
    var sy = orig.start.y + amp * sp.ay * Math.cos(sp.fy * t + sp.py);

    var d = 'M' + f(sx) + ' ' + f(sy);

    for (var i = 0; i < N; i++) {
      var seg = segs[i];
      var p = params[i];
      var anchor = anchors[i];

      // Previous anchor (or displaced start)
      var prevOrig = i === 0 ? orig.start : segs[i - 1].end;
      var prev = i === 0 ? { x: sx, y: sy } : anchors[i - 1];

      // cp1: translate with prev anchor, then rotate around it
      var cp1shifted = {
        x: seg.cp1.x + (prev.x - prevOrig.x),
        y: seg.cp1.y + (prev.y - prevOrig.y)
      };
      var rot1 = amp * p.r1a * Math.sin(p.r1f * t + p.r1p);
      var cp1 = rotateAround(cp1shifted.x, cp1shifted.y, prev.x, prev.y, rot1);

      // cp2: translate with this anchor, then rotate around it
      var cp2shifted = {
        x: seg.cp2.x + (anchor.x - seg.end.x),
        y: seg.cp2.y + (anchor.y - seg.end.y)
      };
      var rot2 = amp * p.r2a * Math.sin(p.r2f * t + p.r2p);
      var cp2 = rotateAround(cp2shifted.x, cp2shifted.y, anchor.x, anchor.y, rot2);

      d += ' C' + f(cp1.x) + ' ' + f(cp1.y) + ' ' + f(cp2.x) + ' ' + f(cp2.y) + ' ' + f(anchor.x) + ' ' + f(anchor.y);
    }

    d += ' L' + f(sx) + ' ' + f(sy) + 'Z';
    return d;
  }

  var ORIG = parsePath(ORIG_D);
  var ORIG_HEADER = parsePath(HEADER_BLOB_D);

  // Random params per blob instance — each point gets its own frequency & phase
  function makeParams(n) {
    return Array.from({ length: n }, function () {
      return {
        // Anchor oscillation (~0.4–0.8 Hz)
        fx: (0.0008 + Math.random() * 0.0008),
        fy: (0.0008 + Math.random() * 0.0008),
        px: Math.random() * Math.PI * 2,
        py: Math.random() * Math.PI * 2,
        ax: 2 + Math.random() * 3,   // amplitude in px
        ay: 2 + Math.random() * 3,
        // Handle 1 rotation (independent)
        r1f: (0.0004 + Math.random() * 0.0006),
        r1p: Math.random() * Math.PI * 2,
        r1a: 0.03 + Math.random() * 0.05,  // ~2–5 degrees
        // Handle 2 rotation
        r2f: (0.0004 + Math.random() * 0.0006),
        r2p: Math.random() * Math.PI * 2,
        r2a: 0.03 + Math.random() * 0.05
      };
    });
  }

  function initCard(card) {
    var pathEl = card.querySelector('.koebi-card__blob path');
    if (!pathEl) return;

    var params = makeParams(ORIG.segs.length);
    function frame(ts) {
      pathEl.setAttribute('d', buildPath(ORIG, params, ts, 1));
      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function initHeader() {
    var pathEl = document.querySelector('.koebi-header-blob path');
    if (!pathEl) return;

    var params = makeParams(ORIG_HEADER.segs.length);
    function frame(ts) {
      pathEl.setAttribute('d', buildPath(ORIG_HEADER, params, ts, 1.2));
      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function init() {
    document.querySelectorAll('.koebi-card').forEach(initCard);
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
